import { useState } from 'react';

const SUBMIT_URL = 'https://readdy.ai/api/form/da08ra6859p3u981e160';

export default function ContactForm() {
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);
    const honeypot = (fd.get('website_alt') as string)?.trim() ?? '';

    if (honeypot) {
      setStatus('success');
      setMessage('感谢您的留言，我们会尽快与您联系！');
      form.reset();
      return;
    }
    fd.delete('website_alt');

    setStatus('loading');
    setMessage('');
    try {
      const res = await fetch(SUBMIT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(fd as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let code = '';
      let serverMsg = '';
      try {
        const parsed = JSON.parse(responseText);
        code = parsed?.code ?? '';
        serverMsg = parsed?.meta?.message ?? parsed?.message ?? parsed?.meta?.detail ?? '';
      } catch {
        serverMsg = responseText;
      }
      if (res.ok && code === 'OK') {
        setStatus('success');
        setMessage('感谢您的留言，我们会尽快与您联系！');
        form.reset();
      } else {
        setStatus('error');
        setMessage(serverMsg || '提交失败，请稍后再试。');
      }
    } catch {
      setStatus('error');
      setMessage('网络异常，请稍后再试。');
    }
  };

  const inputCls =
    'w-full rounded-lg border border-background-200 bg-background-50 px-4 py-2.5 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400';

  return (
    <form data-readdy-form onSubmit={handleSubmit} className="space-y-4">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div>
          <label htmlFor="contact-name" className="mb-1.5 block text-sm font-medium text-foreground-800">您的称呼</label>
          <input id="contact-name" type="text" name="name" required placeholder="请输入称呼" className={inputCls} />
        </div>
        <div>
          <label htmlFor="contact-email" className="mb-1.5 block text-sm font-medium text-foreground-800">邮箱地址</label>
          <input id="contact-email" type="email" name="email" required placeholder="name@example.com" className={inputCls} />
        </div>
      </div>
      <div>
        <label htmlFor="contact-subject" className="mb-1.5 block text-sm font-medium text-foreground-800">留言主题</label>
        <input id="contact-subject" type="text" name="subject" required placeholder="如：番剧推荐、合作咨询" className={inputCls} />
      </div>
      <div>
        <label htmlFor="contact-message" className="mb-1.5 block text-sm font-medium text-foreground-800">留言内容</label>
        <textarea
          id="contact-message"
          name="message"
          required
          maxLength={500}
          rows={5}
          placeholder="请输入您的想法，最多 500 字"
          className={inputCls}
        />
        <p className="mt-1 text-right text-xs text-foreground-400">最多 500 字</p>
      </div>
      {/* 反垃圾蜜罐字段 */}
      <input type="text" name="website_alt" className="hp-field" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />

      <button
        type="submit"
        disabled={status === 'loading'}
        className="w-full rounded-lg bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 hover:bg-primary-600 transition-colors disabled:opacity-60"
      >
        {status === 'loading' ? '提交中…' : '发送留言'}
      </button>

      {status === 'success' && <p className="rounded-lg bg-secondary-100 px-4 py-3 text-sm text-secondary-900" role="status">{message}</p>}
      {status === 'error' && <p className="rounded-lg bg-primary-100 px-4 py-3 text-sm text-primary-700" role="alert">{message}</p>}
    </form>
  );
}